﻿module.exports = {
    "id": "fi",
    "label": "Suomi",
    "rtl": false,

    "translations": {
        "INVALID_LINK_TITLE":           "Linkki Ei Kelpaa",
        "INVALID_LINK_TEXT":            "Käytä sähköpostissa saamaasi linkkiä erotaksesi postituslistoiltamme.",
        "UNSUBSCRIBE_ARE_YOU_SURE":     "Oletko varma, että haluat poistaa tämän sähköpostiosoitteen postituslistoiltamme?",
        "UNSUBSCRIBE_CLICK_CONFIRM":    "Vahvista klikkaamalla alla olevaa \"Eroa\"-painiketta.",
        "YOU_HAVE_BEEN_UNSUBSCRIBED":   "Olet <b>eronnut</b> postituslistoiltamme.",
        "UNSUBSCRIBED_IN_ERROR":        "Jos erosit vahingossa, klikkaa <a href='/resubscribe' class='resubscribe'>Liity Uudelleen</a>-linkkiä.",
        "CANCELLED_STILL_SUBSCRIBED":   "<b>Peruutettu.</b> Olet edelleen <b>mukana</b> postituslistoillamme.",
        "THANK_YOU_FOR_CONTINUING":     "Kiitos, että osallistut kyselyihimme jatkossakin.",
        "EMAIL_ALREADY_UNSUBSCRIBED":   "Tämä sähköpostiosoite on jo <b>poistettu</b> postituslistoiltamme.",
        "CLICK_RESUBSCRIBE_TO_REJOIN":  "Klikkaa alla olevaa \"Liity Uudelleen\"-painiketta, niin pääset takaisin postituslistoillemme.",
        "YOU_HAVE_BEEN_RESUBSCRIBED":   "Olet <b>liittynyt takaisin</b> postituslistoillemme.",
        "YOU_ARE_ALREADY_SUBSCRIBED":   "Olet jo <b>liittynyt</b> postituslistoillemme.",
        "THANK_YOU_FOR_PARTICIPATING":  "Kiitos, että osallistut kyselyihimme.",
        "CHECKING":                     "Tarkistetaan...",
        "UNSUBSCRIBE":                  "Eroa",
        "RESUBSCRIBE":                  "Liity Uudelleen",
        "EMAIL":                        "Sähköpostiosoite",
        "CANCEL":                       "Peruuta"
    }
};

